import { useAuth } from 'contexts/auth';
import { createContext, useState } from 'react';
import apiService from 'services/api';

const PageContext = createContext();

const PageProvider = (props) => {
    const { auth } = useAuth();
    const [filters, setFilters] = useState({
        open: false,
        sort: 'none',
        search: '',
    });
    const [loading, setLoading] = useState(false);
    const [fetchedAssignments, setFetchedAssignments] = useState([]);
    const [pullAssignmentDialog, setPullAssignmentDialog] = useState({ open: false });

    const resetFilters = () => {
        setFilters((current) => ({
            ...current,
            sort: 'none',
        }));
    };

    const getAPIAssignments = async () => {
        setLoading(true);
        const course_id = auth.course_id;
        const accessToken = localStorage.getItem('access_token');
        if (course_id) {
            const APIAssignments = await apiService.getAssignments({ accessToken: accessToken, course_id });
            setFetchedAssignments(APIAssignments);
        }
        setPullAssignmentDialog({ open: true });
        setLoading(false);
    };

    return (
        <PageContext.Provider
            value={{
                loading,
                filters,
                setFilters,
                resetFilters,
                getAPIAssignments,
                fetchedAssignments,
                pullAssignmentDialog,
                setPullAssignmentDialog,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
